export function getUrlQueries () {
  const queryStr = window.location.search.slice(1)
  const queries = {}
  if (!queryStr) {
    return queries
  }
  queryStr.split('&').forEach(function (queryStr) {
    const queryArr = queryStr.split('=')
    queries[queryArr[0]] = queryArr[1]
  })
  return queries
}

export function getEventUrl (url = null) {
  const eventUrl = url !== null ? url : 'https://l-ma.co.jp/events/6433'
  const params = getUrlQueries()
  let getParam = ''
  let roopNum = 1
  for (const param in params) {
    if (roopNum === 1) {
      getParam = `?${param}=${params[param]}`
      roopNum++
    } else {
      getParam = getParam + `&${param}=${params[param]}`
    }
  }
  return getParam ? eventUrl + getParam : eventUrl
}

export function setUrlForEvent (id) {
  const url = getEventUrl()
  const target = document.getElementById(id)
  target.href = url
}
